import * as Yup from 'yup'

import { formatDateToApi, toUkTimezoneDate } from '../../../utils/date'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
  isRemoveAllEntityActionType,
} from '../../Entity'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../Formik'

import {
  NEWSBOARD_POST_PROFILE_TIME_RANGE_END_FIELD_NAME,
  NEWSBOARD_POST_PROFILE_TIME_RANGE_START_FIELD_NAME,
} from './NewsboardPostProfileEditTimeRangeModal.constants'

export function getNewsboardPostProfileEditTimeRangeEmptyValues() {
  return {
    [NEWSBOARD_POST_PROFILE_TIME_RANGE_END_FIELD_NAME]: null,
    [NEWSBOARD_POST_PROFILE_TIME_RANGE_START_FIELD_NAME]: null,
  }
}

export function getNewsboardPostProfileEditTimeRangeActionTypes() {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return Object.values(actionTypeOptions).filter(item =>
    [
      EntityActionTypeSelectOptionValue.Edit,
      EntityActionTypeSelectOptionValue.RemoveAll,
    ].includes(item.value)
  )
}

export function getNewsboardPostProfileEditTimeRangeInitialValues({
  dateFrom,
  dateTo,
  timezone,
}) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
      actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
    [NEWSBOARD_POST_PROFILE_TIME_RANGE_END_FIELD_NAME]: dateTo
      ? toUkTimezoneDate(dateTo, timezone)
      : null,
    [NEWSBOARD_POST_PROFILE_TIME_RANGE_START_FIELD_NAME]: dateFrom
      ? toUkTimezoneDate(dateFrom, timezone)
      : null,
  }
}

export function getNewsboardPostProfileEditTimeRangePayload({
  timezone,
  values,
}) {
  const actionType = values[FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]

  if (isRemoveAllEntityActionType(actionType)) {
    return {
      [NEWSBOARD_POST_PROFILE_TIME_RANGE_END_FIELD_NAME]: null,
      [NEWSBOARD_POST_PROFILE_TIME_RANGE_START_FIELD_NAME]: null,
    }
  }

  const dateFrom = values[NEWSBOARD_POST_PROFILE_TIME_RANGE_START_FIELD_NAME]
  const dateTo = values[NEWSBOARD_POST_PROFILE_TIME_RANGE_END_FIELD_NAME]

  return {
    [NEWSBOARD_POST_PROFILE_TIME_RANGE_END_FIELD_NAME]: dateTo
      ? formatDateToApi(dateTo, timezone)
      : null,
    [NEWSBOARD_POST_PROFILE_TIME_RANGE_START_FIELD_NAME]: dateFrom
      ? formatDateToApi(dateFrom, timezone)
      : null,
  }
}

export function getNewsboardPostProfileEditTimeRangeValidationSchema() {
  return Yup.object({
    [NEWSBOARD_POST_PROFILE_TIME_RANGE_END_FIELD_NAME]: Yup.date()
      .nullable()
      .min(
        Yup.ref(NEWSBOARD_POST_PROFILE_TIME_RANGE_START_FIELD_NAME),
        () => true
      ),
    [NEWSBOARD_POST_PROFILE_TIME_RANGE_START_FIELD_NAME]: Yup.date()
      .nullable()
      .test({
        message: () => true,
        name: 'time-range-required',
        test(startDate) {
          const {
            [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]: actionType,
            [NEWSBOARD_POST_PROFILE_TIME_RANGE_END_FIELD_NAME]: endDate,
          } = this.parent

          if (isRemoveAllEntityActionType(actionType)) {
            return true
          }

          return Boolean(startDate || endDate)
        },
      }),
  })
}
